<template lang="html">
<div>
    <vx-card>
        <div class="mb-1">
            <div style="display: inline-flex; margin: 0px 3px 0px 3px">
                <ul class="flex mt-2">
                    <li>
                        <vs-radio v-model="estadoPerseo" class="ml-2" vs-name="radios1tipo" vs-value="0" @change="getfiltro()">Pendientes</vs-radio>
                    </li>
                    <li>
                        <vs-radio v-model="estadoPerseo" class="ml-2" vs-name="radios1tipo" vs-value="1" @change="getfiltro()">Enviados</vs-radio>
                    </li>
                    <li>
                        <vs-radio v-model="estadoPerseo" class="ml-2" vs-name="radios1tipo" vs-value="2" @change="getfiltro()">Todos</vs-radio>
                    </li>
                </ul>
            </div>
        </div>
        <div class="vx-row">
            <vs-table search class="table users table-hover" style="width: 100%!important;" :max-items="10" pagination :data="agrupados" no-data-text="No hay datos disponibles">
                <template slot="header">
                    <vs-col vs-type="flex" vs-w="auto" class="mt-2 m-3">
                        <vs-chip class="mr-2" color="primary">Cantidad: <b>{{ agrupados.length }}</b></vs-chip>
                    </vs-col>
                </template>
                <template slot="thead">
                    <vs-th width="20%" sort-key="id_factura"> Datos Documento </vs-th>
                    <vs-th width="43%"> Datos cliente </vs-th>
                    <!-- <vs-th> Cantidad y Valor </vs-th> -->
                    <!-- <vs-th width="23%"> Pre-Facturas </vs-th> -->
                    <vs-th width="15%"> Estado </vs-th>
                    <vs-th width="5%"> Acciones </vs-th>
                </template>
                <template slot-scope="{ data }">
                    <vs-tr v-for="(tr, indextr) in data" :key="indextr">
                        <vs-td>
                            <small>{{ tr.id_factura }}</small><br>
                            <b>{{ tr.nombre }}</b><br>
                            Items: {{ tr.item }} <br />
                            libros: {{ tr.libros }} <br />
                            <b>${{ tr.ven_valor }}</b> <br />
                        </vs-td>
                        <vs-td>
                            <tr>
                                <td>
                                    <b>Institución:</b><br>
                                    <small>{{ tr.nombreInstitucion }}</small><br />
                                    <b>Dirección:</b><br>
                                    <small>{{ tr.direccionInstitucion }}</small><br />
                                    <b>Cédula cliente:</b><br>
                                    <small>{{ tr.cedula }}</small><br />
                                    <b>Nombre cliente:</b><br>
                                    <small>{{ tr.nombres }} {{ tr.apellidos }}</small>
                                </td>
                                <td v-if="tr.prefacturas.length > 0">
                                    <b>Prefacturas:</b><br>
                                    <div class="overflow-y-auto h-32">
                                        <div v-for="(t, k) in tr.prefacturas" :key="k">
                                            <p>{{ t.ven_codigo }}</p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </vs-td>
                        <vs-td>
                            <div v-if="tr.estadoPerseo == 1 && tr.est_ven_codigo == 0">
                                <div style="padding:5px; border-radius:5px; color:White; font-size:10px;text-align:center; font-weight:bold; background-color: #0000ff">Enviado a perseo</div>
                                <b>Pedido perseo:</b>
                                <p>{{ tr.pedido_codigo }}</p>
                                <b>Fecha envio:</b>
                                <p>{{ tr.fecha_envio_perseo }}</p>
                                <br>
                            </div>
                            <div v-else-if="tr.estadoPerseo == 1 && tr.est_ven_codigo == 1" style="text-align:center;">
                                <b style="color: red;">Pedido Anulado</b><br>
                                <div style="padding:5px; border-radius:5px; color:White; font-size:17px;text-align:center; font-weight:bold; background-color: #f5515e">
                                    <b>Pedido perseo no valido:</b>
                                    <p>{{ tr.pedido_codigo }}</p>
                                </div>
                                <br>
                            </div>
                            <div v-else-if="tr.estadoPerseo == 0 && tr.est_ven_codigo == 0">
                                <vs-button color="dark" type="border" class="p-3 my-3" @click="confirmEnviarPerseo(tr)">
                                    <i class="fa-brands fa-discord"></i> Enviar a perseo
                                </vs-button>
                                <div style="padding:5px; border-radius:5px; color:White; font-size:10px;text-align:center; font-weight:bold; background-color: black">Pendiente a enviar a Perseo</div>
                            </div>
                        </vs-td>
                        <vs-td>
                            <vs-dropdown vs-custom-content vs-trigger-click>
                                <vs-button class="a-icons" href.prevent icon="more_vert" type="border"></vs-button>
                                <vs-dropdown-menu style="width: 320px;" class="cursor">
                                    <vs-dropdown-item>
                                        <vs-button color="DarkOrchid" type="line" class="w-full" @click="factu= tr;getreporte(tr)">Generar pdf</vs-button>
                                    </vs-dropdown-item>
                                    <vs-dropdown-item>
                                        <vs-button color="danger" type="line" class="w-full" @click="confirmAnular(tr)">
                                            <i class="fa-solid fa-x"></i> Anular pedido
                                        </vs-button>
                                    </vs-dropdown-item>
                                </vs-dropdown-menu>
                            </vs-dropdown>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </div>
        <vs-popup fullscreen :title="`${id}`" v-if="tdo==1&&id" :active.sync="popupImprimir">
            <facturaVue v-if="popupImprimir" :factu="factu" :id="id" @change="change" :op="op" />
        </vs-popup>
    </vx-card>
</div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import vSelect from 'vue-select';
const facturaVue = () => import('./facturaReal.vue');
export default {
    components: {
        flatPickr,
        'v-select': vSelect,
        facturaVue,
    },

    data: () => ({
        datos: [],
        agrupados: [],
        estadoPerseo: 0,
        id: '',
        op: '',
        tdo: 0,
        factu: '',
        ObjectSelected: '',
        popupImprimir: false,
    }),
    mounted() {
        this.estadoPerseo = 0;
        this.$vs.loading();
        this.getagrupados();
        setTimeout(() => {
            this.getfiltro();
            this.$vs.loading.close();
        }, 1000)

    },
    // computed: {
    //     filteredAgrupados() {
    //         if (!this.searchQuery) {
    //             return this.agrupados; // Devuelve todos los datos si no hay búsqueda
    //         }

    //         const query = this.searchQuery.toLowerCase();
    //         return this.agrupados.filter(item => {
    //             return (
    //                 item.ven_codigo.toLowerCase().includes(query) ||
    //                 item.nombreInstitucion.toLowerCase().includes(query) ||
    //                 item.cedula.toLowerCase().includes(query) ||
    //                 (item.nombres + ' ' + item.apellidos).toLowerCase().includes(query)
    //             );
    //         });
    //     },
    // },
    methods: {
        getagrupados() {
            let me = this;
            me.$vs.loading();
            me.$http.get(this.$server_url + 'GetFacturasxAgrupa')
                .then((res) => {
                    me.datos = res.data;
                    me.getfiltro()
                    me.$vs.loading.close();
                })
                .catch((err) => {
                    console.log(err);
                    me.$vs.loading.close();
                });
        },
        getfiltro() {
            let me = this;
            me.agrupados = []
            //TIPO documento=============
            //todas
            if (me.estadoPerseo == 0) {
                let dato = me.datos.filter(p => p.estadoPerseo == 0);
                me.agrupados = dato;
            } else if (me.estadoPerseo == 1) {
                let dato = me.datos.filter(p => p.estadoPerseo == 1);
                me.agrupados = dato;

            } else if (me.estadoPerseo == 2) {
                let dato = me.datos;
                me.agrupados = dato;
            }
        },
        change(e) {
            if (e == true) {
                this.tdo = 0;
            }
        },
        getreporte(tr) {
            this.tdo = 0;
            this.id = tr.id_factura;
            if (tr.idtipodoc == 11) {
                this.tdo = 1;
                this.op = '1';
                console.log('object');
            }
            this.popupImprimir = true;
        },
        //METODOS DE PERSEO
        confirmEnviarPerseo(tr) {
            this.ObjectSelected = tr;
            this.$vs.dialog({
                type: 'confirm',
                color: 'dark',
                title: 'Enviar a Perseo',
                text: `¿Está seguro de enviar lo facturado real ${tr.id_factura} para crear un pedido en Perseo?`,
                acceptText: 'Aceptar',
                accept: this.enviarPerseo,
                cancelText: 'Cancelar',
                cancel: false
            })
        },
        enviarPerseo() {
            let me = this;
            let formData = new FormData();
            formData.append("ven_codigo", this.ObjectSelected.id_factura);
            formData.append("id_empresa", this.ObjectSelected.id_empresa);
            me.$vs.loading();
            this.$http
                .post(this.$server_url + "api/perseo/transaccion/pedidos_crear", formData)
                .then((res) => {
                    if (res.data != null || res.data != undefined || res.data != 0) {
                        me.$vs.loading.close();
                        if (res.data.status == 0) {
                            me.$vs.notify({
                                text: res.data.message,
                                color: "danger",
                                iconPack: "feather",
                                icon: "icon-x",
                            });
                            return;
                        }
                        if (res.data.fault) {
                            me.$vs.notify({
                                text: "Ocurrio un error en el envío a Perseo",
                                color: "danger",
                                iconPack: "feather",
                                icon: "icon-x",
                            });
                            return;
                        }
                        me.getagrupados();
                        me.$vs.notify({
                            text: "Envío a Perseo exitoso",
                            color: "success",
                            iconPack: "feather",
                            icon: "icon-check",
                        });
                    } else {
                        me.$vs.loading.close();
                        me.$vs.notify({
                            text: "Se produjo algún fallo en el envío a Perseo",
                            color: "#F8C471",
                            iconPack: "feather",
                            icon: "icon-check",
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                    me.$vs.loading.close();
                    me.$vs.notify({
                        text: "No se pudo enviar a Perseo",
                        color: "danger",
                        iconPack: "feather",
                        icon: "icon-x",
                    });
                });
        },
        //FIN METODOS DE PERSEO
        confirmAnular(tr) {
            this.ObjectSelected = tr;
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: 'Anular pedido',
                text: `¿Está seguro de anular ${tr.id_factura} ?`,
                acceptText: 'Aceptar',
                accept: this.AnularPedido,
                cancelText: 'Cancelar',
                cancel: false
            })
        },
        AnularPedido() {
            let me = this;
            let formData = new FormData();
            formData.append("ven_codigo", this.ObjectSelected.id_factura);
            formData.append("id_empresa", this.ObjectSelected.id_empresa);
            formData.append("estado", 1);

            me.$vs.loading();

            this.$http
                .post(this.$server_url + "anularPedido", formData)
                .then((res) => {
                    me.$vs.loading.close();
                    if (res.data.success) {

                        this.ObjectSelected.est_ven_codigo = 1;

                        me.$vs.notify({
                            text: `Pedido ${this.ObjectSelected.id_factura} anulado correctamente.`,
                            color: 'success',
                            iconPack: 'feather',
                            icon: 'icon-check',
                        });
                    } else {
                        me.$vs.notify({
                            text: `No se pudo anular el pedido ${this.ObjectSelected.id_factura}.`,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-x',
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                    me.$vs.loading.close();
                    me.$vs.notify({
                        text: "Ocurrió un error al intentar anular el pedido.",
                        color: "danger",
                        iconPack: "feather",
                        icon: "icon-x",
                    });
                });
        },

    },
}
</script>
